import Vue from 'vue'
import App from './App.vue'
import VueRouter from  'vue-router'
//引入路由器
import router from './router'
Vue.use(VueRouter)
//引入store
import store from './store/index'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "./assets/index";
import SlideVerify from 'vue-monoplasty-slide-verify';
// 导入编译器
//导入v-md-edit 插件
import VMdEditor from '@kangc/v-md-editor';
//导入v-md-edit 插件样式
import '@kangc/v-md-editor/lib/style/base-editor.css';
//导入代码高亮模式，为github模式
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js';
//导入代码高亮样式
import '@kangc/v-md-editor/lib/theme/style/github.css';
//导入highlightjs
import hljs from 'highlight.js';
// 全局注册filters 
import * as filters from './utils/filters'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
//全局使用 v-md-edit 插件
import ButtonFix from "./components/ButtonFix.vue"
Vue.component("ButtonFix",ButtonFix)
Vue.use(VMdEditor);
//配置v-md-edit插件的代码高亮为github模式，使用highlight.js
VMdEditor.use(githubTheme, {
  Hljs: hljs,
});
Vue.use(SlideVerify);
Vue.use(ElementUI);
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
